import { render, staticRenderFns } from "./marketingChannelList.vue?vue&type=template&id=4b6bb7e2&scoped=true&"
import script from "./marketingChannelList.vue?vue&type=script&lang=js&"
export * from "./marketingChannelList.vue?vue&type=script&lang=js&"
import style0 from "./marketingChannelList.vue?vue&type=style&index=0&id=4b6bb7e2&prod&scoped=true&lang=scss&"
import style1 from "./marketingChannelList.vue?vue&type=style&index=1&id=4b6bb7e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bb7e2",
  null
  
)

export default component.exports